/** @jsx jsx */
import { Badge, jsx } from "theme-ui";
import React from "react";
import { Link } from "gatsby";
import { Icon } from "@iconify/react";

export type CartButtonProps = { quantity: number };
export const CartButton: React.FC<CartButtonProps> = ({ quantity }) => {
  return (
    <Link
      aria-label={`Shopping Cart with ${quantity} items`}
      to="/cart"
      sx={{ position: "relative" }}
    >
      <Icon icon={"bi:cart3"} sx={{ color: "primary" }} height="24" />
      {quantity > 0 && (
        <Badge
          variant="circle"
          bg="secondary"
          sx={{ position: "absolute", top: "-10px", right: "-10px" }}
        >
          {quantity}
        </Badge>
      )}
    </Link>
  );
};

export default CartButton;
